import axiosInt from './axios';
import { validateAccessToken } from './validateAccessToken';

const { default: axios } = require('axios');

let maintenanceMode = localStorage.getItem('maintenanceMode') === 'true';

const validateRequestForToken = (url = '') => {
  if (
    ['/auth/admin-change-password', '/auth/send-verification-email']
      .map((path) => url.includes(path))
      .filter(Boolean).length > 0
  )
    return true;
  if (url.includes('/auth')) return false;
  return true;
};

axios.interceptors.request.use(
  async (config) => {
    // const session = await Auth.currentSession();
    // const token = await session.getIdToken().getJwtToken();
    if (!validateRequestForToken(config.url)) {
      return config;
    }

    const validatedToken = await validateAccessToken();

    if (!validatedToken) {
      return config;
    }

    if (typeof validatedToken === 'string')
      axiosInt.defaults.headers.common.Authorization = `Bearer ${validatedToken}`;

    const token = axiosInt.defaults.headers.common.Authorization;

    if (token && !config.headers.Authorization)
      config.headers.Authorization = token;

    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (maintenanceMode) {
      maintenanceMode = false;
      localStorage.removeItem('maintenanceMode');
      localStorage.removeItem('maintenanceModeDuration');
    }
    return response;
  },
  async (error) => {
    // if (error.response.status === 403) Auth.signOut();
    if (error.response.status === 503) {
      maintenanceMode = true;
      localStorage.setItem('maintenanceMode', true);
      localStorage.setItem('maintenanceModeDuration', error.response.data.duration);
    } else if (maintenanceMode) {
      maintenanceMode = false;
      localStorage.removeItem('maintenanceMode');
      localStorage.removeItem('maintenanceModeDuration');
    }

    return Promise.reject(error);
  }
);

export function doPost(url, payload, params, headers, cancelToken) {
  return new Promise(async (resolve, reject) => {
    if (cancelToken) await cancelToken.cancel();
    axios
      .post(url, payload, {
        params,
        headers
      })
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err?.response?.data));
  });
}

export function doGet(url, params, headers, cancelToken, options = {}) {
  return new Promise(async (resolve, reject) => {
    // if (cancelToken) await cancelToken.cancel();

    axios
      .get(url, {
        params,
        headers,
        ...options
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => reject(err?.response?.data));
  });
}

export function doGetById(url, params, headers, cancelToken) {
  return new Promise(async (resolve, reject) => {
    if (cancelToken) await cancelToken.cancel();
    axios
      .get(url, { params, headers })
      .then(({ data }) => resolve({ ...data, data: data.data[0] }))
      .catch((err) => reject(err?.response?.data));
  });
}

export function doPut(url, payload, params, headers, cancelToken) {
  return new Promise(async (resolve, reject) => {
    if (cancelToken) await cancelToken.cancel();
    axios
      .put(url, payload, { params, headers })
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err?.response?.data));
  });
}

export function doDelete(url, params, headers, cancelToken) {
  return new Promise(async (resolve, reject) => {
    if (cancelToken) await cancelToken.cancel();
    axios
      .delete(url, { params, headers })
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err?.response?.data));
  });
}

export function doPatch(url, payload, params, headers, cancelToken) {
  return new Promise(async (resolve, reject) => {
    if (cancelToken) await cancelToken.cancel();
    axios
      .patch(url, payload, { params, headers })
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err?.response?.data?.message));
  });
}

const ApiCallers = {
  doPost,
  doGet,
  doGetById,
  doPut,
  doPatch,
  doDelete
};

export default ApiCallers;
